import React, { useCallback } from 'react';

import ConfirmDialog from 'components/confirm-dialog';
import { useProductWizardContext } from 'pages/menu/components/product-wizard';
import { ProductWizardStep } from 'pages/menu/components/product-wizard/types';
import { useProductWizardFlow } from 'pages/menu/components/product-wizard/use-product-wizard-flow';
import { t } from 'state/intl/translations';

import { BodyComponent } from '../body-component';

export const CloseConfirmationDialog = () => {
  const { closeWizard, currentFlowStep } = useProductWizardFlow();

  const {
    showCloseDialog,
    setShowCloseDialog,
    restoreSlotsSelectionSnapshot,
  } = useProductWizardContext();
  const heading = t('productDetailCloseHeading');
  const content = t('productDetailCloseContent');

  const confirmLabel = t('leaveNow');
  const cancelLabel = t('continueCustomizing');
  const shouldShowDialog =
    showCloseDialog && currentFlowStep.step !== ProductWizardStep.ProductCustomization;

  const onConfirm = useCallback(() => {
    restoreSlotsSelectionSnapshot();
    setShowCloseDialog(false);
    closeWizard();
  }, [restoreSlotsSelectionSnapshot, closeWizard, setShowCloseDialog]);

  const onCancel = useCallback(() => {
    setShowCloseDialog(false);
  }, [setShowCloseDialog]);

  return (
    <ConfirmDialog
      showDialog={shouldShowDialog}
      modalAppearanceEventMessage="Product Detail Close Dialog"
      bodyComponent={<BodyComponent heading={heading} content={content} />}
      confirmLabel={confirmLabel}
      cancelLabel={cancelLabel}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};
